import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login as iniciarSesion } from '../../servicios/auth';
import './login.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import md5 from 'md5';
import { FaEye, FaEyeSlash, FaEnvelope, FaLock } from 'react-icons/fa';
const logo = process.env.PUBLIC_URL + '/tigo_logo.svg';

const SignInScreen = () => {

    const [data, setData] = useState({
        username: '',
        password: '',
        isValidUser: true,
        isValidPassword: true,
        showPassword: false
    });

    const navigate = useNavigate();

    const textInputChange = (val) => {
        setData({
            ...data,
            username: val,
            check_textInputChange: val.trim().length >= 4,
            isValidUser: val.trim().length >= 4
        });
    };

    const handlePasswordChange = (val) => {
        if (val.trim().length >= 8) {
            setData({ ...data, password: md5(val), isValidPassword: true });
        } else {
            setData({ ...data, password: val, isValidPassword: false });
        }
    };

    const toggleShowPassword = () => {
        setData({ ...data, showPassword: !data.showPassword });
    };

    const loginHandle = async () => {
        if (data.username.length === 0 || data.password.length === 0) {
            toast.error('Complete la información por favor');
            return;
        }

        try {
            // El servidor valida y abre la sesión (cookie httpOnly). El navegador
            // ya no guarda al usuario ni ningún token.
            await iniciarSesion(data.username, data.password);
            navigate('/home');
        } catch (e) {
            toast.error(e.message || 'No se pudo iniciar sesión. Verifica tu conexión.');
        }
    };

    const onKeyDown = (e) => {
        if (e.key === 'Enter') loginHandle();
    };

    return (
        <div className="login-page">
            <div className="login-shell">
                {/* Panel de marca */}
                <div className="login-brand">
                    <div className="login-brand__logo-wrap">
                        <img src={logo} alt="Tigo" className="login-brand__logo" />
                    </div>
                    <h2 className="login-brand__title">Gestión de Leads</h2>
                    <p className="login-brand__text">
                        Plataforma corporativa para la asignación y seguimiento de leads.
                    </p>
                </div>

                {/* Panel de formulario */}
                <div className="login-form">
                    <h1 className="login-form__title">Iniciar sesión</h1>
                    <p className="login-form__subtitle">Ingresa tus credenciales para continuar</p>

                    <label className="login-label">Email</label>
                    <div className="login-field">
                        <FaEnvelope className="login-field__icon" />
                        <input
                            type="text"
                            placeholder="Su correo electrónico"
                            className="form-control"
                            onChange={(val) => textInputChange(val.target.value)}
                            onKeyDown={onKeyDown}
                        />
                    </div>
                    {!data.isValidUser && (
                        <p className="login-error">El nombre de usuario debe tener al menos 4 caracteres.</p>
                    )}

                    <label className="login-label">Contraseña</label>
                    <div className="login-field">
                        <FaLock className="login-field__icon" />
                        <input
                            type={data.showPassword ? 'text' : 'password'}
                            placeholder="Su contraseña"
                            className="form-control"
                            onChange={(val) => handlePasswordChange(val.target.value)}
                            onKeyDown={onKeyDown}
                        />
                        <button
                            type="button"
                            className="login-field__toggle"
                            onClick={toggleShowPassword}
                            aria-label="Mostrar u ocultar contraseña"
                        >
                            {data.showPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                    </div>
                    {!data.isValidPassword && (
                        <p className="login-error">La contraseña debe tener al menos 8 caracteres.</p>
                    )}

                    <button type="button" className="login-forgot">¿Olvidó su contraseña?</button>

                    <button className="login-btn" onClick={loginHandle}>
                        Iniciar sesión
                    </button>
                </div>
            </div>

            <ToastContainer position="top-right" autoClose={3000} theme="colored" />
        </div>
    );
};

export default SignInScreen;
